import { render, staticRenderFns } from "./RespostasPorInstituicao.vue?vue&type=template&id=577a6a03&scoped=true"
import script from "./RespostasPorInstituicao.vue?vue&type=script&lang=js"
export * from "./RespostasPorInstituicao.vue?vue&type=script&lang=js"
import style0 from "./RespostasPorInstituicao.vue?vue&type=style&index=0&id=577a6a03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577a6a03",
  null
  
)

export default component.exports